export const SEARCH_MEMBER_DETAIL = {
  name: '获取会员详情',
  api: '${ACTIVITY}/bcp-crm-dev/api/B/external/customer/info',
  method: "get",
  doc: "http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378308"
};
export const SEARCH_MEMBER_QRCODE = {
  name: 'B端对接中台会员详细信息(可解析会员卡加密的二维码)',
  api: '${ACTIVITY}/bcp-crm-dev/api/B/external/customer/enhance/info',
  method: "get",
  doc: "http://wiki.rt.com:8090/pages/viewpage.action?pageId=26383787"
};
export const COUPON_AVAILABLE_LIST = {
  name: '获取可用的优惠券列表',
  api: '${ACTIVITY}/bcp-coupon-dev/api/B/couponInstance/available/list/byCid',
  method: "post"
};

export const COUPON_DETAIL = {
  name: '获取可用优惠券详情',
  method: 'post',
  api: '${ACTIVITY}/bcp-coupon-dev/api/B/instanceWriteOff/writeOff'
};
export const FACECOUPON_LIST = {
  name: '面对面赠券—券批列表',
  api: '${FACE2FACE}/app-face/app/coupon/list',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#56dd9434fd982a153e4e55339456e998',
};
